import { Stack } from '@mui/material';

import { Lock01Icon } from '@/components/icons/Lock01Icon';
import { Callout } from '@/components/notifications/Callout/Callout';
import { useRequiredParam } from '@/hooks/useRequiredParam';
import { UpdateClient } from '@/modules/forms/household/Update';
import { PRIVATE_HOUSEHOLD_TOOLTIP } from '@/modules/household/components/PrivateHouseholdIndicator';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';

export function KeyDetailsPage() {
  const householdId = useRequiredParam('householdId');
  const { isPrivateHousehold } = useHouseholdDetailsContext();

  return (
    <Stack height="100%">
      <Stack p={2} flex={1}>
        {isPrivateHousehold && (
          <Callout severity="info-high" sx={{ mb: 2 }}>
            <Stack direction="row" alignItems="center" gap={1}>
              <Lock01Icon size={16} color="currentColor" aria-hidden />
              {PRIVATE_HOUSEHOLD_TOOLTIP}
            </Stack>
          </Callout>
        )}
        <UpdateClient householdId={householdId} />
      </Stack>
    </Stack>
  );
}
